import { useRef, useState } from "react";
import { GripVertical } from "lucide-react";

export default function BeforeAfter({ before, after, alt = "" }) {
    const [pos, setPos] = useState(50);
    const ref = useRef(null);
    const move = (clientX) => {
        if (!ref.current) return;
        const rect = ref.current.getBoundingClientRect();
        const p = Math.max(0, Math.min(100, ((clientX - rect.left) / rect.width) * 100));
        setPos(p);
    };
    return (
        <div
            ref={ref}
            data-testid="before-after-slider"
            className="relative w-full aspect-[4/3] rounded-xl overflow-hidden select-none cursor-ew-resize bg-stone-200"
            onMouseMove={(e) => e.buttons === 1 && move(e.clientX)}
            onTouchMove={(e) => move(e.touches[0].clientX)}
            onClick={(e) => move(e.clientX)}
        >
            <img src={after} alt={`${alt} depois`} className="absolute inset-0 w-full h-full object-cover" draggable={false} />
            <div className="absolute inset-0 overflow-hidden" style={{ width: `${pos}%` }}>
                <img src={before} alt={`${alt} antes`} className="absolute inset-0 h-full object-cover" style={{ width: `${100 * (100 / pos)}%`, maxWidth: "none" }} draggable={false} />
            </div>
            <div className="absolute top-4 left-4 bg-stone-950/80 text-white text-xs font-medium uppercase tracking-wider px-3 py-1 rounded-full">Antes</div>
            <div className="absolute top-4 right-4 bg-[hsl(var(--moss))] text-white text-xs font-medium uppercase tracking-wider px-3 py-1 rounded-full">Depois</div>
            <div className="absolute top-0 bottom-0 w-0.5 bg-white shadow-lg pointer-events-none" style={{ left: `${pos}%` }}>
                <div className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-10 h-10 bg-white rounded-full flex items-center justify-center shadow-xl">
                    <GripVertical className="w-5 h-5 text-stone-900" />
                </div>
            </div>
        </div>
    );
}
